<template>
  <div>
    <div class="container-fluid pt-0 row mx-0 bg-primary">
      <!-- 业务介绍开始 -->
      <div
        class="
          container-fluid
          mx-auto
          card
          col-sm-12 col-md-12 col-lg-10 col-xl-10
          mycard-scale
          my-4
        "
      >
        <page-breadcrumb :items="crumbs" />
        <h1 class="h3 my-3">关于广西桂运宝科技有限公司</h1>
        <h2 class="h5 card-title font-weight-bold my-3">
          <i class="fa fa-building me-3" aria-hidden="true"></i>公司简介
        </h2>
        <p class="card-text p2em">
          广西桂运宝科技有限公司总部坐落于广西工业重镇柳州市，是广西本土领先的大宗货物网络货运综合服务商。公司扎根大宗货运行业十余年，已构建「线上智能数字底座 + 线下实体运力网络」一体化全链路运营体系，专注为工矿、建材、农林、钢铁、水泥、电厂、有色等实体产业客户，提供安全、高效、降本、低碳的大宗整车综合运输解决方案。业务立足广西，辐射华南、华东、西南区域，致力成为大宗物流数智化核心底座，赋能区域货运产业发展。
        </p>

        <h2 class="h5 card-title font-weight-bold mt-4">
          <i class="fa fa-laptop me-3" aria-hidden="true"></i>数智化核心能力
        </h2>
        <p class="card-text p2em">
          桂运宝自主研发全套物流数字化系统矩阵，以「AI 大模型 + 行业标准数据」为底层技术架构，融合货运 APP 系统、车辆调度系统、业务培训系统、智能体执行平台，打造面向大宗物流行业的开放数字底座。
        </p>
        <p class="p2em">
          平台实现货源智能聚合、运力画像匹配、AI 语音自动播报的全流程自动化调度，让算法深度介入业务交易决策。持续推进电子面单与智能调度全覆盖，推动传统货运由粗放管理转向精细化智慧运营。依托 AI 智能体平台形成「数据采集 — 智能研判 — 落地优化」的持续迭代闭环运营。
        </p>
        <img
          class="image-640 my-4"
          src="@/assets/images/platform.jpg"
          alt="桂运宝货运平台界面"
          width="863"
          height="541"
          loading="lazy"
        />

        <h2 class="h5 card-title font-weight-bold">
          <i class="fa fa-trophy me-3" aria-hidden="true"></i>核心竞争优势
        </h2>
        <p class="p2em">
          <strong>一、全链路智能运营</strong><br />
          依托自研 AI 物流技术底座，打通货源聚合、车货精准匹配、AI 调度播报、订单确认全业务流程，实现调度响应更快、客户综合运输成本更省。
        </p>
        <p class="p2em">
          <strong>二、绿色运力保障</strong><br />
          布局自有新能源重卡商业化运营，车辆零排放；同时整合标准化社会运力，包括顺路车、回头车、返程车及运输车队运力，可灵活承接多场景大宗货运需求，实现绿色低碳运营，也保障运力供给稳定可靠。
        </p>
        <p class="p2em">
          <strong>三、标准化可复制运营体系</strong><br />
          采用「总部强中台 + 属地轻前端」组织架构，依托自研业务培训系统，沉淀十余年大宗货运实操经验，搭建完整标准化作业流程库与分层人才培育体系。面向新员工、加盟商团队、合作司机开展分层培训、线上学习与数字化考核，实现全岗位能力标准化输出。统一的作业规范与人才培养机制，保障跨区域服务品质稳定，支持网点快速复制扩张。
        </p>
        <p class="p2em">
          <strong>四、全流程合规安全管控</strong><br />
          作为新规首批承运平台升级企业，依托运输全程可视化，严格落实运单、资金、票据、证件、定位「五流合一」，做到货物运输安全、财税业务全程合规，大幅降低企业经营风险。
        </p>
        <img
          class="image-640 my-4"
          src="@/assets/images/sys-map.jpg"
          alt="桂运宝系统架构"
          width="1080"
          height="519"
          loading="lazy"
        />

        <h2 class="h5 card-title font-weight-bold">
          <i class="fa fa-road me-3" aria-hidden="true"></i>发展历程
        </h2>
        <p class="p2em">
          <strong>筑基初创期｜2010‑2022</strong><br />
          核心团队深耕广西大宗公路货运十载，积累扎实的行业货源渠道与运力资源。2021 年桂运宝科技正式注册并上线自研货运平台，首批通过广西交通运输厅网络货运线上服务能力认定并接入省级监管平台，完成从传统货运企业向数字化网络货运平台的战略转型。
        </p>
        <p class="p2em">
          <strong>深耕扩张期｜2022‑2025</strong><br />
          深耕广西本土大宗货运市场，与区内多家大型工矿、建材企业达成长期战略合作；搭建「自有运力 + 社会化合作车队」双层运力池，创新构建「平台 + 汽车后市场」业务生态。2024 年启动广西全域布局，落地「总部强中台 + 属地轻前端」两级运营架构，设立多家属地分公司，持续扩大区域服务覆盖。
        </p>
        <p class="p2em">
          <strong>智能进阶期｜2025‑至今</strong><br />
          公司迈入规范化、规模化高质量发展新阶段。落地 AI 大模型与智能体技术在货运场景的深度应用，实现货源聚合、车货匹配、AI 调度自动化；投入首批自有新能源重卡商业化运营，践行绿色低碳发展战略。依托自研培训系统搭建标准化运营与人才培育体系，持续扩大新能源运力规模，着力构建覆盖西南、联通东盟的数智化绿色大宗物流网络，向智慧物流科技企业全面升级。
        </p>

        <h2 class="h5 card-title font-weight-bold mt-2">
          <i class="fa fa-flag me-3" aria-hidden="true"></i>发展愿景
        </h2>
        <p class="card-text p2em mb-4">
          桂运宝坚守「以人为根、合规安全、绿色低碳、数智筑基」的核心服务理念，赋能大宗货运行业数字化转型、规范化升级。持续深耕 AI 技术与大宗物流场景融合，夯实实体运力底盘，拓展全域服务网络，致力于打造区域领先、国内一流的智慧大宗物流科技企业，依托数智化物流底座，赋能实体经济高质量发展。
        </p>
      </div>
      <!-- Grid column -->
    </div>
  </div>
</template>

<script>
import { PAGES } from "@/seo/site";

/**
 * 关于我们 / 公司介绍页
 * @module About
 */
export default {
  name: "About",
  data: function () {
    return {
      crumbs: PAGES.about.crumbs,
    };
  },
};
</script>
<style>
</style>
